import 'isomorphic-fetch';
import { config } from 'config';

// Solo las formas de pago con "Mueve caja" habilitada: son las unicas que
// descuentan de la caja del usuario, asi que son las unicas que aplican aca.
export const soloMuevenCaja = (formasPago = []) =>
	formasPago.filter(f => parseInt(f.muevecaja) === 1 && f.estado !== "B");

export const api = {
	caja: {
		async saldo(id) {
			const response = await fetch(config.URL_API + '/caja/saldo/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async saldos() {
			const response = await fetch(config.URL_API + '/caja/saldos', {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async desglose(id) {
			const response = await fetch(config.URL_API + '/caja/desglose/' + id, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/caja&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
		async movimiento(data) {
			const response = await fetch(config.URL_API + '/caja/movimiento', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/x-www-form-urlencoded',
				},
				body: JSON.stringify(data)
			});
			const responseData = await response.json();
			return responseData;
		},
	},
	mpago: {
		async getAll(params = '') {
			const response = await fetch(config.URL_API + '/formas_pago&' + params, {
				method: 'GET',
				headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
			});
			const data = await response.json();
			return data;
		},
	},
};
